import { TableGridMode } from "consts/table";

import transactions from 'config/filters/transactions.json';
import merchants from 'config/filters/merchants.json';
import users from 'config/filters/users.json';
import merchantPayoutSummaryFiles from 'config/filters/merchantPayouts/summaryFiles.json';
import merchantPayoutFiles from 'config/filters/merchantPayouts/files.json';
import merchantPayoutCalculations from 'config/filters/merchantPayouts/calculations.json';
import merchantPayoutFileTaxCalculations from 'config/filters/merchantPayouts/fileTaxCalculations.json';
import transactionsMerchantPayoutIncrementsPivot from 'config/filters/transactionsMerchantPayoutIncrementsPivot.json';
import merchantPayoutIncrementTaxes from 'config/filters/merchantPayouts/incrementTaxes.json';
import merchantPayoutIncrements from 'config/filters/merchantPayouts/increments.json';
import merchantPayoutIncrementExchangeRates from 'config/filters/merchantPayouts/incrementExchangeRates.json';
import whitelistedConsumers from 'config/filters/consumers/whitelisted.json';
import manualBulkKYCsImportHistory from 'config/filters/manualBulkKYCsImportHistory.json';

import { typed, type Config } from "ui/widgets/Filters/hooks/useFiltersConfigParser";
import InvalidTableGridModeException from "../exceptions/InvalidTableGridModeException";

const configRegistry = new Map<TableGridMode, Config[]>([
    [TableGridMode.Transaction, typed(transactions)],
    [TableGridMode.Merchant, typed(merchants)],
    [TableGridMode.User, typed(users)],
    [TableGridMode.MerchantPayoutsSummaryFiles, typed(merchantPayoutSummaryFiles)],
    [TableGridMode.MerchantPayoutsFiles, typed(merchantPayoutFiles)],
    [TableGridMode.MerchantPayoutCalculations, typed(merchantPayoutCalculations)],
    [TableGridMode.MerchantPayoutFileTaxCalculations, typed(merchantPayoutFileTaxCalculations)],
    [TableGridMode.TransactionsMerchantPayoutIncrementsPivot, typed(transactionsMerchantPayoutIncrementsPivot)],
    [TableGridMode.MerchantPayoutIncrementTaxes, typed(merchantPayoutIncrementTaxes)],
    [TableGridMode.MerchantPayoutIncrements, typed(merchantPayoutIncrements)],
    [TableGridMode.MerchantPayoutIncrementExchangeRates, typed(merchantPayoutIncrementExchangeRates)],
    [TableGridMode.ManualBulkKYCsImportHistory, typed(manualBulkKYCsImportHistory)],
    [TableGridMode.WhitelistedConsumer, typed(whitelistedConsumers)],
]);

export default function useTableFiltersConfig(mode: TableGridMode) {
    if (!configRegistry.has(mode)) {
        throw new InvalidTableGridModeException(
            `Unknown table grid mode`,
            {}
        );
    }

    return configRegistry.get(mode)!;
};
